import { createFileRoute } from '@tanstack/react-router';
import { findingsRouteOptions } from '../-workspaceRouteOptions';

export const Route = createFileRoute('/_authed/$orgSlug/findings')({
  ...findingsRouteOptions,
});
